import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import {
  Message,
  Header,
  Button,
  Form,
  Segment,
  Divider,
  List,
  Label
} from "semantic-ui-react";
import BotonGuardar from "../../shared/botones/BotonGuardar";
import Servicios from "./formularioInscripcion/Servicios";
import Observaciones from "./formularioInscripcion/Observaciones";
import Pago from "./formularioInscripcion/Pago";
import Legal from "./formularioInscripcion/Legal";
import DatosPersonales from "./formularioInscripcion/DatosPersonales";
import DatosContacto from "./formularioInscripcion/DatosContacto";
import ContactoAristas from "./formularioInscripcion/ContactoAristas";
import AMPA from "./formularioInscripcion/AMPA";
import FormaDePago from "./formularioInscripcion/FormaDePago";
import OpcionesAdicionales from "./formularioInscripcion/OpcionesAdicionales";

const propTypes = {
  action: PropTypes.func.isRequired
};

class FormularioInscripcion extends React.Component {
  state = {
    importe: 0,
    precioEscuela: 0,
    descuentoAmpa: 0,
    descuentoHermano: 0,
    visible: false
  };

  componentDidMount() {
    this.setState({ visible: true });
  }

  preSubmit = values => {
    values.iban = `${values.iban1} ${values.iban2} ${values.iban3} ${
      values.iban4
    } ${values.iban5} ${values.iban6}`;

    this.props.handleSubmit(values => this.props.action(values));
  };

  setDescuentoHermano = () =>
    this.setState({ descuentoHermano: this.props.precios.descuentoHermano });

  setPrecioEscuela = valor => this.setState({ precioEscuela: valor });

  render() {
    const {
      handleSubmit,
      pristine,
      reset,
      submitSucceeded,
      precios
    } = this.props;

    return (
      <Segment>
        <Form>
          <DatosPersonales />
          <Divider section />
          <DatosContacto />
          <Divider section />
          <Servicios
            setPrecioEscuela={this.setPrecioEscuela}
            precios={this.props.precios}
            colegio={this.props.colegio}
            provincia={
              this.props.provincia ? this.props.provincia.toUpperCase() : ""
            }
          />
          <Divider section />

          {precios &&
            precios.hasOwnProperty("opcionAgosto") && (
              <React.Fragment>
                <OpcionesAdicionales opcionAgosto={precios.opcionAgosto} />
                <Divider section />
              </React.Fragment>
            )}

          {precios &&
            (!precios.hasOwnProperty("sinAmpa") ||
              (precios.hasOwnProperty("sinAmpa") && !precios.sinAmpa)) && (
              <React.Fragment>
                <AMPA precios={precios} />
                <Divider section />
              </React.Fragment>
            )}

          <Observaciones />
          <Divider section />
          <FormaDePago />
          <Divider section />
          <Pago />

          <Divider section />
          <Legal />
          <Divider section />

          <Segment basic padded="very">
            <Segment basic textAlign="center">
              {this.props.resguardo && (
                <Message>
                  <Header as="h4">
                    La preinscripción se realizó con éxito
                  </Header>
                  <Header as="h4">
                    {`Su número de resguardo es: ${this.props.resguardo}`}
                  </Header>
                  <p>
                    Conserve este número, le servirá para identificar su
                    inscripción
                  </p>
                  <Header as="h2">Recuerde</Header>
                  <Header as="h4">
                    Para completar la inscripción deberá hacernos llegar el
                    justificante de pago de una de las siguientes maneras:
                  </Header>
                  <List>
                    <List.Item>
                      <Header as="h4">
                        Por email, a la dirección{" "}
                        <Label basic>escuelas@grupoaristas.com</Label>
                      </Header>
                    </List.Item>
                    <List.Item>
                      <Header as="h4">
                        Por la web, en la dirección
                        <Label
                          basic
                          as="a"
                          href="https://extragestor.grupoaristas.com/inscripciones"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://extragestor.grupoaristas.com/inscripciones
                        </Label>{" "}
                        y pulsando en el botón{" "}
                        <Label
                          basic
                          as="a"
                          href="https://extragestor.grupoaristas.com/inscripciones"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Adjuntar documento de pago
                        </Label>
                      </Header>
                    </List.Item>
                  </List>
                  <Header as="h4">
                    No olvide indicar el nombre del alumno y/o el número de
                    resguardo en el pago o el correo.
                  </Header>
                  <p>
                    Una vez completada la inscripción, se le enviará un email de
                    confirmación a la dirección indicada.
                  </p>
                </Message>
              )}
            </Segment>

            <BotonGuardar
              disabled={pristine || submitSucceeded}
              floated="right"
              buttontext="Guardando"
              icon="checkmark"
              action={handleSubmit(values => this.props.action(values))}
            />
            <BotonGuardar
              basic
              disabled={pristine || submitSucceeded}
              floated="right"
              buttonText="Descartar Cambios"
              icon="cancel"
              action={reset}
            />
            {submitSucceeded && (
              <div>
                <Button
                  icon="print"
                  content="Imprimir"
                  onClick={() => window.print()}
                />
                Puede imprimir esta hoja como resguardo
              </div>
            )}
          </Segment>
          <Divider section />
          <ContactoAristas />
        </Form>
      </Segment>
    );
  }
}

FormularioInscripcion.propTypes = propTypes;

export default reduxForm({ form: "FormularioAlumno" })(FormularioInscripcion);



// WEBPACK FOOTER //
// ./src/pages/inscripciones/hojaInscripcion/FormularioInscripcion.jsx